<div class="equipment-preset-summary">
  <img *ngIf="preset.imageFile" [src]="preset.imageFile" class="preset-image mb-5" alt="" />

  <ng-container *ngIf="preset.description">
    <div
      *ngIf="preset.description | BBCodeToHtml | async as html; else presetDescriptionLoading"
      [innerHTML]="html"
      class="preset-description mb-5"
    ></div>
    <ng-template #presetDescriptionLoading>
      <div class="preset-description mb-5">
        <small><fa-icon animation="spin" icon="spinner"></fa-icon> {{ "Loading content..." | translate }}</small>
      </div>
    </ng-template>
  </ng-container>

  <div *ngFor="let section of equipmentConfigs; let lastSection = last" [class.mb-4]="!lastSection">
    <div *ngIf="equipmentItems[section.property].length > 0">
      <strong class="d-block mb-3">{{ section.displayName }}</strong>
      <div class="d-flex flex-wrap gap-3">
        <astrobin-equipment-item-display-name
          *ngFor="let item of equipmentItems[section.property]"
          [enableBrandLink]="false"
          [enableKlassIcon]="true"
          [enableNameLink]="false"
          [enableSummaryPopover]="false"
          [item]="item"
          [showFrozenAsAmbiguous]="false"
          [showItemUnapprovedInfo]="false"
          [showRetailers]="true"
          (click)="onEquipmentItemClicked(item)"
          class="equipment-item"
        ></astrobin-equipment-item-display-name>
      </div>
    </div>
  </div>

  <div *ngIf="!!searchModel" class="preset-images mt-5">
    <h5 class="d-block mb-3">{{ "Imaged with this setup" | translate }}</h5>
    <astrobin-image-search [model]="searchModel" [showStaticOverlay]="false"></astrobin-image-search>
  </div>
</div>
